import { Box, Center, Container, Heading, Text } from "@chakra-ui/react";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { useGetCookiePolicyQuery } from "../../features/cmsApi";
import RichTextRenderer from "../../common/RichTextRenderer";

function CookiePolicy() {
  const { data } = useGetCookiePolicyQuery();


  return (
    <Container my={10} maxW="container.lg">
      <Center>
        <Heading size="2xl" fontWeight={"semibold"} color="green.700" mb={8}>
          {data?.data?.title || "Cookie Policy"}
        </Heading>
      </Center>
      <Box my={10}>
        {data?.data && <RichTextRenderer content={data?.data?.content} />}
      </Box>
    </Container>
  );
}

export default CookiePolicy;
